import { render, staticRenderFns } from "./modalDetalleRelacion.vue?vue&type=template&id=4854f117&scoped=true&"
import script from "./modalDetalleRelacion.vue?vue&type=script&lang=js&"
export * from "./modalDetalleRelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854f117",
  null
  
)

export default component.exports